import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { createProcedure as createProcedureURL } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function createProcedure(params: TVariables): Promise<TResult> {
  const response = await fetch(createProcedureURL(params.AccountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: {
    AccountId: number;
    ProcedureId: number;
    ProcedureName: string;
  };
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  AccountId: number;
  CID: string | undefined;
  SID: string | undefined;
  PID: string | undefined;
  AccountName: string | undefined;
};

type TSnapshot = unknown;

function useCreateProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const accountProcedure = await createProcedure(params);
    if (accountProcedure.Data) {
      queryClient.invalidateQueries([
        'get_procedure_builder_procedures',
        params.AccountId,
      ]);
      queryClient.invalidateQueries(['get_procedure'], {
        refetchInactive: true,
      });
    } else if (accountProcedure.Errors) throw accountProcedure;
    return accountProcedure;
  });
}

export { useCreateProcedure };
